// extracted by mini-css-extract-plugin
export default {"wrapper":"Uploading__wrapper---uZ6y","meter":"Uploading__meter--Firyc","move":"Uploading__move--Yrffg"};